import React, { Component } from "react";
import {
  Router,
  RouterProps,
  Styled
} from "../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import { Container, UncontrolledTooltip } from "reactstrap";
import { errorNotification } from "../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faShoppingCart,
  faSpinner,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import { ExternoDetalleDispatcher } from "../../containers/externoDetalle/ExternoDetalle.dispatcher";
import { ExternoDetalleStore } from "../../containers/externoDetalle/ExternoDetalle.store";
import ExternoDetalle from "../../../types/ExternoDetalle";
import permissionCodes from "../../../utils/permissionCodes";
import { userHasPermission } from "../../../utils/accessTree";
import { BFF_URL, IMAGES_ENDPOINT } from "../../../utils/constants";
import ExternoDetalleTabs from "./ExternoDetalle.tabs";
import ExternoDetalleInfo from "./ExternoDetalle.info";

const { MENU_CARRITO } = permissionCodes;

interface Props
  extends ExternoDetalleDispatcher,
    ExternoDetalleStore,
    RouterProps<any> {}
interface State {}

@Router()
@Styled(s)
export default class ExternoDetalleComponent extends Component<Props, State> {
  async componentDidMount(): Promise<void> {
    this.props.clearExternosDetalle();
    const { idPersona } = this.props.match.params;
    const preview = await this.props.getExternoDetalleByIdPersona(idPersona);

    if (!preview.fulfilled) {
      errorNotification("Error al cargar los datos del externo");
    }
  }

  render() {
    if (!this.props.externoDetalle) {
      return (
        <Container>
          <FontAwesomeIcon icon={faSpinner} pulse />
        </Container>
      );
    }

    const persona = this.props.externoDetalle;
    const hasPhoto = persona.fotoStorageId > 0;
    const personaHref = getPersonaHref(persona);
    const eyeTooltipId = `persona-ver-${persona.idPersona}`;
    const cartTooltipId = `persona-carrito-${persona.idPersona}`;

    return (
      <Container>
        <div className={s.info}>
          {/* Fotografía de la persona */}
          <div
            className={`${s.foto} ${
              hasPhoto ? s.fotoConImagen : s.fotoSinImagen
            }`}
          >
            {hasPhoto ? (
              <img
                src={`${BFF_URL}${IMAGES_ENDPOINT}/${persona.fotoStorageId}`}
                alt={`Fotografía de ${persona.nombreCompleto || "persona"}`}
              />
            ) : (
              <FontAwesomeIcon icon={faUser} />
            )}
          </div>

          {/* Header con datos a la derecha de la foto */}
          <div
            className={`${s.persona} ${
              hasPhoto ? s.personaConImagen : s.personaSinImagen
            }`}
          >
            <div className={s.heading}>
              {/* Nombre completo (grande) */}
              <h3>{persona.nombreCompleto}</h3>

              {/* Acciones (íconos) a la derecha del nombre */}
              <div className={s.actions}>
                {personaHref && (
                  <>
                    <a
                      className={s.actionLink}
                      href={personaHref}
                      target="_blank"
                      id={eyeTooltipId}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </a>
                    <UncontrolledTooltip
                      placement="bottom"
                      target={eyeTooltipId}
                    >
                      Ver persona
                    </UncontrolledTooltip>
                  </>
                )}

                {userHasPermission(MENU_CARRITO) && (
                  <>
                    <a
                      className={s.actionLink}
                      href={`/productos/carrito/${persona.idPersona}`}
                      target="_blank"
                      id={cartTooltipId}
                    >
                      <FontAwesomeIcon icon={faShoppingCart} />
                    </a>
                    <UncontrolledTooltip
                      placement="bottom"
                      target={cartTooltipId}
                    >
                      Ver carrito
                    </UncontrolledTooltip>
                  </>
                )}
              </div>
            </div>

            {/* División de nombre y parte inferior */}
            <hr />

            {/* Identificador de la persona, al lado de la foto */}
            <p>ID Persona: {persona.idPersona}</p>
          </div>
        </div>

        {/* Cards informativos */}
        <ExternoDetalleInfo detalle={persona} />

        {/* Tabs */}
        <ExternoDetalleTabs
          detalle={this.props.externoDetalle}
          {...({} as any)}
        />
      </Container>
    );
  }
}

function getPersonaHref(persona: ExternoDetalle): string {
  switch (persona.tipo) {
    case "CLIENTE_TITULAR":
    case "CLIENTE_INTEGRANTE":
    case "CLIENTE":
      return `/socio/${persona.idPersona}/detalle`;
    case "PROSPECTO":
      return `/prospecto/${persona.idPersona}/detalle`;
    case "CONCESIONARIO":
      return `/concesionarios/${persona.idPersona}/detalle`;
    case "CORPORATIVO":
      return `/corporativos/${persona.idPersona}/detalle`;
    case "EXTERNO":
      return `/externo/${persona.idPersona}/detalle`;
    case "EMPLEADO":
      return `/empleado/${persona.idPersona}/detalle`;
    default:
      return "";
  }
}
